export const OWNER_TYPE_JITSU = 1;
export const OWNER_TYPE_CLIENT = 2;
export const OWNER_TYPE_COURIER = 3;

export const OWNER_TYPE_MAIN = 'Main';
export const OWNER_TYPE_MOBILE = 'Mobile Hub';
export const OWNER_TYPE_SIMULATION = 'Simulation';
export const OWNER_TYPE_CLIENT_STR = 'client';
export const OWNER_TYPE_COURIER_STR = 'courier';

export const TYPE_MAIN = 1;
export const TYPE_MOBILE_HUB = 2;

export const defaultTypeOptions = () => {
  return [
    {
      value: OWNER_TYPE_MAIN,
      title: OWNER_TYPE_MAIN,
    },
    {
      value: OWNER_TYPE_MOBILE,
      title: OWNER_TYPE_MOBILE,
    },
    {
      value: OWNER_TYPE_SIMULATION,
      title: OWNER_TYPE_SIMULATION,
    },
  ];
};

export const defaultWarehouseTypeOptions = [
  { title: "Jitsu's", label: "Jitsu's", value: OWNER_TYPE_JITSU },
  { title: "Client's", label: "Client's", value: OWNER_TYPE_CLIENT },
  { title: "DSP's", label: "DSP's", value: OWNER_TYPE_COURIER },
];
